import styled, { AnyStyledComponent } from 'styled-components';
import { Input } from 'antd';

export const GenericInputTextAreaStyle = styled(
  Input.TextArea as unknown as AnyStyledComponent,
)``;
